import React from 'react';
import { Box } from '@mui/material';

const pulsingDotStyle = {
  '@keyframes pulse': {
    '0%': { opacity: 1, transform: 'scale(1)' },
    '50%': { opacity: 0.5, transform: 'scale(1.3)' },
    '100%': { opacity: 1, transform: 'scale(1)' },
  },
} as const;

const PulsingDot: React.FC<{ color?: string; size?: number }> = ({ color = '#22c55e', size = 8 }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-block',
      width: size,
      height: size,
      borderRadius: '50%',
      bgcolor: color,
      animation: 'pulse 1.5s ease-in-out infinite',
      ...pulsingDotStyle,
    }}
  />
);

export default PulsingDot;
